<template>
  <div class="dcb-partner-lp">
    <a
      id="partner"
      style="margin-top: -120px; position: absolute"
    ></a>
    <Heading
      tag="h2"
      align="center"
      size="md"
      spaces-bottom
    >
      Hier können Sie auch mit „Zahl einfach per Handyrechnung“ einkaufen
    </Heading>
    <Heading
      tag="h3"
      size="sm"
      font-weight="regular"
      align="center"
      spaces-bottom
    >
      „Zahl einfach per Handyrechnung“ können Sie in den gängigen App Stores und bei vielen
      Streaming- und Mobilitätsanbietern nutzen.
    </Heading>
    <div class="dcb-partner-lp__logos">
      <DraggableScroller
        class="dcb-partner-lp__scroller"
        has-pagination
        has-arrow
        has-arrow-desktop
        show-single-active-pagination
        :autoplay-time="3000"
        :autoplay-elements="2"
      >
        <div
          v-for="partner in partners"
          :key="partner.alt"
          class="dcb-partner-lp__logo"
        >
          <ImageElement
            lazy
            :alt="partner.alt"
            render-without-figure
            :src="partner.src"
          />
        </div>
      </DraggableScroller>
    </div>

    <LinkButton
      tag="a"
      to="https://www.telekom.de/optionsuebersicht/mobilfunk/zahl-einfach-per-handyrechnung"
      target="_blank"
      rel="noopener"
      primary
      is-external
    >
      Weitere Partner entdecken
    </LinkButton>
  </div>
</template>

<script setup lang="ts">
import { ImageElement, LinkButton, Paragraph, Heading } from '@i22-td-smarthome/component-library';
import DraggableScroller from '~/components/draggable-scroller.vue';

const partners = [
  {
    alt: 'AppStore',
    src: '/content/content-images/dcb/25d3c4b3d3a93fb4bc292015ec05b492/app-store.svg',
  },
  {
    alt: 'Google Play',
    src: '/content/content-images/dcb/f15b2aa41a6caf7fcc0180cce8ec6798/google-play.svg',
  },
  {
    alt: 'Netflix',
    src: '/content/content-images/dcb/partner/00b1bcdacf4d730b05b9e1cbaaf43e7a/netflix-logo.svg',
  },
  {
    alt: 'easypark',
    src: '/content/content-images/dcb/partner/ab27b3f99f1d1b9ed323d1bbd86f8f10/easypark-logo.svg',
  },
  {
    alt: 'PlayStation Store',
    src: '/content/content-images/dcb/partner/6a2ffc03174f38cab589e7bc07a249a2/playstation-store-logo.svg',
  },
  {
    alt: 'nextbike',
    src: '/content/content-images/dcb/partner/e841542399ba1b8cf22878d48cb4643f/nextbike-logo.svg',
  },
  {
    alt: 'Xbox',
    src: '/content/content-images/dcb/partner/cda7e8c5edab112fe0f5574339101cf0/xbox-logo.svg',
  },
  {
    alt: 'Spotify',
    src: '/content/content-images/dcb/partner/25366749f8e0b2350cfdffe8c1a1c65b/spotify-logo.svg',
  },
  {
    alt: 'DAZN',
    src: '/content/content-images/dcb/partner/2421fc216aea459e0349902ff0617ace/dazn-logo.svg',
  },
  {
    alt: 'Sony',
    src: '/content/content-images/dcb/partner/cc745a44dbbe1fb83cf0e34d1e9b4dc6/sony-logo.svg',
  },
  {
    alt: 'deezer',
    src: '/content/content-images/dcb/partner/cd04a0dbe71dc6b66f5976c634c87c13/deezer-logo.svg',
  },
];
</script>

<style scoped lang="scss">
@use 'assets/base' as *;

.dcb-partner-lp {
  margin-bottom: $grid-base * 5;
  text-align: center;
  @include mq($mq-md) {
    margin-bottom: $grid-base * 8;
  }

  &__scroller {
    :deep(.draggable-scroller__container) {
      display: flex;
      width: 100%;
      padding: $grid-base;
      grid-gap: $grid-base * 2;
      align-items: center;

      > * {
        flex: 0 0 calc(50% - $grid-base * 2);
        padding: $grid-base $grid-base * 2;
        @include mq($mq-sm) {
          flex: 0 0 calc(50% - $grid-base * 2);
        }
        @include mq($mq-md) {
          flex: 0 0 calc(25% - $grid-base * 2);
        }
      }
    }
  }

  &__logos {
    margin-bottom: 2rem;
    img {
      display: inline-block;
      max-height: 53px;
      max-width: 100%;
      object-fit: contain;
    }
  }

  &__logo {
    flex: 0 0 calc(50% - $grid-base);
    text-align: center;
  }
}
</style>
